export const createDocumentInCollectionFromClient = async (
  collectionSlug: string,
  body: Record<string, unknown>,
  locale?: string,
): Promise<Response> => {
  const localeParam = locale ? `?locale=${locale}` : '';

  const response = await fetch(`/api/${collectionSlug}${localeParam}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(body),
  });

  return response;
};
